import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  imageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  planName: 'this is a planmame',
  amount: '₹575',
  oldAmount: '₹599',
  subText: 'Subtext',
  infoTagText: 'offer',
  infoTagProps: {
    text: 'Validity: 90 days',
    iconName: 'InfoIcon',
    size: 'sm',
    iconPosition: 'left',
    subType: 'default'
  }
}, getTestId('PackAmountWidgetContainer'));